import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState, lazy, Suspense } from 'react';
import { getDesktopOrMobile } from './Utils/deviceDetails';
import Protect from './Components/ProtectedRoutes/protect';
import './App.css';
import UniversalLoader from './Components/Loader';
import LandingPage1 from './Components/PepsodentGumCheck/LandingPage';
const Ryzehealth = lazy(() => import('./Components/Ryzehealth'));

const Ipad = lazy(() => import('./Components/Unilever/Ipad'));
const PageNotFound = lazy(() => import('./Components/PageNotFound'));
const Landscape = lazy(() => import('./Components/Landscape'));
const QrCode = lazy(() => import('./Components/QrCode'));
const Selfie = lazy(() => import('./Components/FrontCameraFlow'));
const TPScanSelfie = lazy(() => import('./Components/FrontCameraTpScan'));
const Unilever = lazy(() => import('./Components/Unilever'));
const StarInsurance = lazy(() => import('./Components/StarInsurance'));
const Vietnamese = lazy(() => import('./Components/Unilever-vietnamese'));
const PeriGumCheck = lazy(() => import('./Components/PeriGumCheck'));
const BearnFlow = lazy(() => import('./Components/BearnFlow'));
const Edental = lazy(() => import('./Components/FrontCameraFlow/edental'));
const PlaqueCheckerPG = lazy(() => import('./Components/PlaqueChecker-PG'));
const Dashboard = lazy(() => import('./Components/Dashboard'));
const AutoDetection = lazy(() => import('./Components/AutoDetection'));
const PepsodentGumCheckIndia = lazy(() => import('./Components/PepsodentGumCheckIndia'));


const App = () => {

    const [isDesktop, setDeviceType] = useState(false)
    const [isLandscape, setLandscape] = useState(window.innerWidth > window.innerHeight)
    const handleOrientation = () => {
        detectDevice()
        setLandscape(window.innerWidth > window.innerHeight)
        document.documentElement.style.setProperty("--browser-offset", `calc(var(--vh, 1vh) * 100 - ${window.innerHeight}px)`);
    }

    const detectDevice = () => {
        const isDesktopWindows = getDesktopOrMobile()
        setDeviceType(isDesktopWindows)
    }

    useEffect(() => {
        window.addEventListener("resize", handleOrientation)
        handleOrientation()
        // window.open()
        return () => {
            window.removeEventListener("resize", handleOrientation)
        }
    }, [])

    const Spinner = () => (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: '100%',
            background: 'transparent'
        }} aria-hidden="false" role="status" aria-label="Loading">
            <svg width="64" height="64" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" focusable="false">
                <circle cx="50" cy="50" r="35" stroke="#1976d2" strokeWidth="8" strokeLinecap="round" fill="none" opacity="0.25" />
                <path d="M50 15 A35 35 0 0 1 85 50" stroke="#1976d2" strokeWidth="8" strokeLinecap="round" fill="none">
                    <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="0.9s" repeatCount="indefinite" />
                </path>
            </svg>
        </div>
    )


    return (
        <div className="App">
            {
                isDesktop ?
                    <Routes>
                        <Route path="/" element={<QrCode />} />
                        <Route path="/:dentalOfficeName" element={<QrCode />} />
                        <Route path="*" element={<QrCode />} />
                    </Routes> :
                    isLandscape ? <Landscape /> :
                        <Suspense fallback={
                            <UniversalLoader />
                        }>
                            <Routes>
                                <Route exact path="/" element={<Protect />} />
                                <Route exact path="/AI/:company/*" element={<Ryzehealth />} />
                                {/* <Route exact path="/ryzehealth" element={<Ryzehealth company="ryzehealth" />} />
                                <Route exact path="/idealhealth" element={<Ryzehealth company="idealhealth" />} /> */}
                                <Route exact path="/meswak" element={<Navigate to="/auto/meswak" replace />} />
                                <Route exact path="/guardian/*" element={<BearnFlow />} />
                                <Route exact path="/stayhealth/*" element={<BearnFlow />} />
                                {/* <Route exact path="/camps/*" element={<BearnFlow />} /> */}
                                <Route exact path="/selfie/*" element={<Selfie />} />
                                <Route exact path="/edental/*" element={<Edental />} />
                                <Route exact path="/:company/:cameraside/*" element={<StarInsurance />} />
                                <Route exact path="/unilever/*" element={<Unilever />} />
                                <Route exact path="/tpscan/:tpscanName/*" element={<TPScanSelfie />} />
                                {/* <Route exact path="/tpscan/:tpscanName" element={<TpScanLanding />} /> */}
                                {/* <Route path="/tpscan/bearn" element={<BernFlow />} />
                            <Route path='/tpscan/benepower/report' element={<BernFlow />} /> */}
                                {/* <Route path="/:ph_no" element={<ReadPhNo />} /> */}
                                <Route path="/ipad" element={<Ipad />} />
                                <Route exact path="/pg/*" element={<PlaqueCheckerPG />} />
                                <Route path="/vietnam/*" element={<Vietnamese />} />
                                <Route path="/peri-gum/*" element={<PeriGumCheck />} />
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/pepsodent-gum/*" element={<LandingPage1 />} />
                                <Route path="/pepsodent-gumcheck-india/:uid?/*" element={<PepsodentGumCheckIndia />} />
                                <Route path="/loader" element={<UniversalLoader />} />
                                <Route path="/auto/:company/*" element={<AutoDetection />} />
                                <Route path="*" element={<PageNotFound />} />
                                {/* <Route path="/dental-form" element={<DentalInsuranceForm />} /> */}
                                {/* <Route path="/multi-step-form" element={<MultiStepForm />} /> */}
                                {/* Except tpscan/:tpscanName we are automating the uid's */}
                            </Routes>
                        </Suspense>
            }

        </div >
    );
}

export default App;